export default function PostSkeleton() {
  return (
    <div className="border rounded p-3 placeholder-glow">
      <div className="placeholder col-12 mb-2" style={{ height: "180px" }}></div>
      <div className="placeholder col-8 mb-2"></div>
      <div className="placeholder col-6"></div>
    </div>
  );
}
